import { render, staticRenderFns } from "./CardTypeColumnTemplate.vue?vue&type=template&id=1be4aba8"
import script from "./CardTypeColumnTemplate.vue?vue&type=script&lang=js"
export * from "./CardTypeColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports